import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface DivergenceIndicatorProps {
  /** Whether to show the indicator */
  show: boolean;
  /** Original value from registry */
  registryValue: string | undefined;
  /** Field label for tooltip context */
  fieldLabel?: string;
}

/**
 * DivergenceIndicator - Shows a yield/warning icon when a field value
 * differs from the official registry data.
 *
 * Used to inform users that their entered value doesn't match what's
 * in the Swiss Commercial Register (Zefix), without blocking them.
 */
export function DivergenceIndicator({
  show,
  registryValue,
  fieldLabel,
}: DivergenceIndicatorProps) {
  if (!show || registryValue === undefined) {
    return null;
  }

  const tooltipText = fieldLabel
    ? `${fieldLabel} differs from registry: "${registryValue}"`
    : `Differs from registry: "${registryValue}"`;

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center justify-center cursor-help">
            <AlertTriangle className="h-4 w-4 text-warning" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-sm">
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
